import { render } from "./index.vue?vue&type=template&id=de6a84fc&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=de6a84fc&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=de6a84fc&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de6a84fc"]])

export default __exports__